import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "userSlice",
  initialState: {
    user: [],
    status: "",
  },
  reducers: {
    setDetail: (state, action) => {
      state.user = action.payload;
    },

    validateUser: (state, action) => {
      // fecth api from backend and mathch credntials

      if (
        "admin@gmail.com" === action.payload.userEmail &&
        "1234" === action.payload.userPassword
      ) {
        state.status = "success";
        return;
      }
      state.status = "failed";
    },
    logOutUser: (state, action) => {
      sessionStorage.removeItem("user_auth_token");
      window.localStorage.removeItem("jsonData");
      window.localStorage.removeItem("ewayBillJson");

      state.status = "failed";
      state.user = [];
    },
  },
});

export default userSlice.reducer;

export const { setDetail, validateUser, logOutUser } = userSlice.actions;
